export default "__VITE_ASSET__BpIvoKEL__"